// extracted by mini-css-extract-plugin
export var actionIcon = "_qu-0";